$(document).ready(function() {
  function stopAndRemoveVideo($item) {
    const $video = $item.find('video');
    if ($video.length) {
      const videoElement = $video[0];
      videoElement.pause();
      videoElement.src = '';
      videoElement.load(); // Unload the video content
      $video.remove();
    }
    $item.removeClass('video-playing');
  }

  // Handle click events on carousel items
  $('.ugc-carousel-item').on('click', function(e) {
    e.preventDefault();
    const $item = $(this);
    
    // Ignore clicks on video controls
    if ($(e.target).closest('video').length) {
      return;
    }
    
    const videoUrl = $item.data('video-url');
    
    // If this item is currently playing a video, stop it
    if ($item.hasClass('video-playing')) {
      stopAndRemoveVideo($item);
      return;
    }

    // Stop any other playing videos
    $('.ugc-carousel-item.video-playing').each(function() {
      stopAndRemoveVideo($(this));
    });

    // Create and play new video
    const $video = $('<video playsinline webkit-playsinline controls>');
    $video.attr({
      'src': videoUrl,
      'preload': 'metadata'
    });
    
    // Add video to container and show it
    $item.find('.video-container').append($video);
    
    // Add event listeners
    const videoElement = $video[0];
    
    videoElement.addEventListener('ended', function() {
      if (!videoElement.seeking) {  // Only stop if not seeking
        stopAndRemoveVideo($item);
      }
    });
    
    videoElement.addEventListener('error', function() {
      console.error('Error playing video');
      stopAndRemoveVideo($item);
    });

    // Add seeking event handlers
    videoElement.addEventListener('seeking', function() {
      // Do nothing while seeking to prevent unwanted removal
    });

    videoElement.addEventListener('seeked', function() {
      // Resume playback after seeking is complete
      videoElement.play().catch(function(error) {
        console.error('Error playing video after seek:', error);
      });
    });
    
    // Wait for metadata before playing
    videoElement.addEventListener('loadedmetadata', function() {
      // Add playing class to show video and hide thumbnail
      $item.addClass('video-playing');
      
      videoElement.play().catch(function(error) {
        console.error('Error playing video:', error);
        stopAndRemoveVideo($item);
      });
    });
  });

  // Pause and remove videos when scrolling out of view
  let scrollTimeout;
  $(window).on('scroll', function() {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function() {
      $('.ugc-carousel-item.video-playing').each(function() {
        const rect = this.getBoundingClientRect();
        const isVisible = (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= window.innerHeight &&
          rect.right <= window.innerWidth
        );
        
        if (!isVisible) {
          stopAndRemoveVideo($(this));
        }
      });
    }, 150);
  });

  // Clean up any playing videos when leaving the page
  $(window).on('beforeunload', function() {
    $('.ugc-carousel-item.video-playing').each(function() {
      stopAndRemoveVideo($(this));
    });
  });
}); 